<template>
  <div class="cards">
    <div>
      <div class="swiper-container" id="cards-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="image-box"></div>
            <div class="info-box">
              <div class="title">Ad eos saepe lucilius</div>
              <div class="desc">
                At eripuit signiferumque sea, vel ad mucius molestie, cu
                labitur.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box"></div>
            <div class="info-box">
              <div class="title">Ad eos saepe lucilius</div>
              <div class="desc">
                At eripuit signiferumque sea, vel ad mucius molestie, cu
                labitur.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box"></div>
            <div class="info-box">
              <div class="title">Ad eos saepe lucilius</div>
              <div class="desc">
                At eripuit signiferumque sea, vel ad mucius molestie, cu
                labitur.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box"></div>
            <div class="info-box">
              <div class="title">Ad eos saepe lucilius</div>
              <div class="desc">
                At eripuit signiferumque sea, vel ad mucius molestie, cu
                labitur.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box"></div>
            <div class="info-box">
              <div class="title">Ad eos saepe lucilius</div>
              <div class="desc">
                At eripuit signiferumque sea, vel ad mucius molestie, cu
                labitur.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box"></div>
            <div class="info-box">
              <div class="title">Ad eos saepe lucilius</div>
              <div class="desc">
                At eripuit signiferumque sea, vel ad mucius molestie, cu
                labitur.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box"></div>
            <div class="info-box">
              <div class="title">Ad eos saepe lucilius</div>
              <div class="desc">
                At eripuit signiferumque sea, vel ad mucius molestie, cu
                labitur.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box"></div>
            <div class="info-box">
              <div class="title">Ad eos saepe lucilius</div>
              <div class="desc">
                At eripuit signiferumque sea, vel ad mucius molestie, cu
                labitur.
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  mounted() {
    this.swiperInit();
  },
  methods: {
    //  初始化swiper
    swiperInit() {
      new Swiper("#cards-swiper", {
        slidesPerView: "auto",
        spaceBetween: 12,
        centeredSlides: true,
        // centeredSlidesBounds: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
$fontSize: 16px;
.cards {
  overflow: hidden;
  .swiper-slide {
    width: auto;
    opacity: 0.3;
    transition: opacity 0.4s;
  }
  .swiper-slide-prev,
  .swiper-slide-active,
  .swiper-slide-next{
    opacity: 1;
  }
  .image-box {
    width: 450px;
    height: 458px;
    background-color: #e8cca7;
  }
  .info-box {
    margin-top: 20px;
    text-align: center;
    .title {
      margin-bottom: (6px / $fontSize) * 1rem;
      font-size: 1.25rem;
      font-weight: 700;
    }
    .desc {
      width: 362px;
      margin: 0 auto;
    }
  }
}
</style>